import { Injectable } from '@angular/core';
import { HttpService } from '@app/@core/services/http.service';
import { API_ENDPOINTS } from '@app/shared/constants/apiconstants';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SurrenderService {

  constructor(
    private httpService : HttpService
  ) { }

  fetchSurrender(payload:any){
    return this.httpService.post(API_ENDPOINTS.FETCH_SURRENDER,payload);
  }
  getSurrenderApplicationData(payload:any){
    return this.httpService.post(API_ENDPOINTS.GET_SURRENDER_APPLICATION_DATA,payload);
  }
  createSurrenderApplication(payload:any){
    return this.httpService.post(API_ENDPOINTS.CREATE_SURRENDER_APPLICATION,payload);
  }
  getSurrenderActivationId(): Observable<any> {
    return this.httpService.get('/dashboard/surrender-activationId');
  }
  insertSurrenderNotes(payload:any): Observable<any>{
    return this.httpService.post('/application-flow/insert-surrender-notes',payload);
  }
  updateSurrenderNotes(payload:any): Observable<any>{
    return this.httpService.post('/application-flow/update-surrender-notes',payload);
  }
  deleteSurrenderNotes(payload:any): Observable<any>{
    return this.httpService.post('/application-flow/delete-surrender-notes',payload);
  }
  submitApplication(payload:any):Observable<any>{
    return this.httpService.post('/registration/update-status',payload);
  }
  selectSurrenderNotes(payload:any): Observable<any>{
    return this.httpService.post('/application-flow/select-surrender-notes',payload);
  }
  finalDeterminationSubmition(payload:any):Observable<any>{
    return this.httpService.post('/dashboard/update-final-determination',payload);
  }
  updateLicenseRequestSurrender(payload:any): Observable<any>{
    return this.httpService.post('/dashboard/request-surrender-license',payload);
  }
  updateEndorseSurrender(payload:any): Observable<any>{
    return this.httpService.post('/dashboard/request-surrender-endorsements',payload);
  }
  updateSurrenderLicenseFlag(payload:any): Observable<any>{
    return this.httpService.post('/dashboard/update-license-analyst-flag',payload);
  }
  updateSurrenderEndorseFlag(payload:any): Observable<any>{
    return this.httpService.post('/dashboard/update-endorse-analyst-flag',payload);
  }
}
